module.exports = __webpack_public_path__ + "sunsemweb/img/china.3e3fb09d.svg";